// Sentiments accordion controller — universal init that wires every
// .sentiments-accordion on the page. No-op if no accordions exist, so
// safe to call from the global boot.
//
// Behaviour:
//   - Click on .__head toggles its sibling .__body-wrap open/closed
//   - Keyboard: Enter / Space already work via native <button>
//   - Optional: root carries [data-accordion-single] -> opening one item
//     closes the others (FAQ-style). Default is multi-open (PDP-style).
//   - aria-expanded / aria-hidden / data-state are synchronized on every
//     toggle so screen readers + CSS stay in lock-step.
//
// Markup contract is documented in src/styles/accordion.scss.

export function initAccordion() {
	const accordions = document.querySelectorAll('.sentiments-accordion');
	if (!accordions.length) return;

	accordions.forEach((root) => {
		const isSingle = root.hasAttribute('data-accordion-single');
		const items = Array.from(root.querySelectorAll('.sentiments-accordion__item'));
		if (!items.length) return;

		items.forEach((item) => {
			const head = item.querySelector('.sentiments-accordion__head');
			const body = item.querySelector('.sentiments-accordion__body-wrap');
			if (!head || !body) return;

			// Ensure aria/id wiring exists. If the markup didn't set
			// aria-controls / body id, synthesize a stable pair.
			if (!body.id) {
				body.id = `sentiments-accordion-${Math.random().toString(36).slice(2, 9)}`;
			}
			if (!head.getAttribute('aria-controls')) {
				head.setAttribute('aria-controls', body.id);
			}

			// Seed initial state from data-state="open" if present.
			const seedOpen = item.dataset.state === 'open';
			setItemState(item, head, body, seedOpen);

			head.addEventListener('click', () => {
				const willOpen = item.dataset.state !== 'open';

				if (willOpen && isSingle) {
					// Close every sibling first.
					items.forEach((other) => {
						if (other === item) return;
						const oHead = other.querySelector('.sentiments-accordion__head');
						const oBody = other.querySelector('.sentiments-accordion__body-wrap');
						if (oHead && oBody) setItemState(other, oHead, oBody, false);
					});
				}

				setItemState(item, head, body, willOpen);
			});
		});
	});
}

function setItemState(item, head, body, isOpen) {
	if (isOpen) {
		item.dataset.state = 'open';
		head.setAttribute('aria-expanded', 'true');
		body.setAttribute('aria-hidden', 'false');
	} else {
		delete item.dataset.state;
		head.setAttribute('aria-expanded', 'false');
		body.setAttribute('aria-hidden', 'true');
	}
}
